export const LOGO_URL =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_0391ea67-05df-42a3-a691-19d3f5d5bce8/artifacts/73a81252e87da6b4_WhatsApp%20Image%202026-10-28%20at%2018.00.39.jpeg";


export const FLAG_PHOTO_URL =
  "https://customer-assets-0z36b82j.emergentagent.net/job_neapolis-mc--8clzroy7/artifacts/8670ded7fb730532_836703918_2119319072056858_1522917546503661061_n.png.jpeg";

export const GALLERY = [
  {
    url: FLAG_PHOTO_URL,
    title: "La Bandiera al Vento",
    caption: "Due soci, una Harley e i colori del Neapolis Free Chapter.",
    span: "md:col-span-4 md:row-span-2",
  },
  {
    url: "https://customer-assets-39nsmqrw.emergentagent.net/job_0391ea67-05df-42a3-a691-19d3f5d5bce8/artifacts/a01c36e90290601b_7a468aa0-a1d9-418d-83e9-17a7db2067da.JPG",
    title: "Raduno sotto le Pinete Campane",
    caption: "Pino secolare, fratellanza e rombo di motori.",
    span: "md:col-span-2 md:row-span-2",
  },
  {
    url: "https://customer-assets-39nsmqrw.emergentagent.net/job_0391ea67-05df-42a3-a691-19d3f5d5bce8/artifacts/aec445497ae3554e_IMG_3382.webp",
    title: "Sosta sul Golfo di Napoli",
    caption: "Caschi schierati di fronte al mare e al Vesuvio.",
    span: "md:col-span-2",
  },
  {
    url: "https://customer-assets-39nsmqrw.emergentagent.net/job_0391ea67-05df-42a3-a691-19d3f5d5bce8/artifacts/c2eb6707ad6f509d_IMG_3368.webp",
    title: "In cammino verso la meta",
    caption: "Strada, stivali impolverati e passione libera.",
    span: "md:col-span-2",
  },
  {
    url: "https://customer-assets-39nsmqrw.emergentagent.net/job_0391ea67-05df-42a3-a691-19d3f5d5bce8/artifacts/35cee9593f28aac2_WhatsApp%20Image%202026-10-27%20at%2019.02.54.jpeg",
    title: "Curve sul Vesuvio",
    caption: "Il vento della Campania sulle nostre Harley e Custom.",
    span: "md:col-span-2",
  },
  {
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_neapolis-mc--8clzroy7/artifacts/650271ab5102dfd0_PHOTO-2026-10-24-13-47-47.jpg",
    title: "Gilet e Stemma Limited Edition",
    caption: "Le toppe che raccontano chi siamo.",
    span: "md:col-span-3",
  },
  {
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_neapolis-mc--8clzroy7/artifacts/f6b08bd50fda6b08_PHOTO-2026-09-12-16-12-03.jpg",
    title: "Spirito del Neapolis Free Chapter",
    caption: "Passione, inchiostro e V-Twin.",
    span: "md:col-span-3",
  },
];

export const EVENTS = [
  {
    date: "17 MAG 2026",
    day: "17",
    month: "MAGGIO",
    title: "Raid del Vesuvio & Costiera Amalfitana",
    location: "Partenza da Napoli, Piazza del Plebiscito",
  },
  {
    date: "21 GIU 2026",
    day: "21",
    month: "GIUGNO",
    title: "Bikes'n'Fun Summer Night Run",
    location: "Lungomare Caracciolo & Pozzuoli",
  },
  {
    date: "12 SET 2026",
    day: "12",
    month: "SETTEMBRE",
    title: "Anniversario Neapolis Free Chapter — 7 Anni",
    location: "Clubhouse Neapolis",
  },
];

export const STATS = [
  { label: "Anno di Fondazione", value: "2019" },
  { label: "Sede", value: "Napoli" },
  { label: "Motto", value: "Bikes'n'Fun" },
  { label: "Chilometri Percorsi", value: "+150.000" },
];
